import { useState, useEffect } from 'react';
import { $t } from 'hooks/i18n';
import { Column } from 'primereact/column';
import { DataSource } from 'components/DataSource';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { ProgressBar } from 'primereact/progressbar';
import { Title } from 'components/Title';

import { Tag } from "primereact/tag";
import axios from "axios";
export default function EmicollectionstatusPage() {
	
	const [pageReady, setPageReady] = useState(true);
	const [data, setData] = useState([]);
const [loading, setLoading] = useState(false);
const [userid, setuserid] = useState(null);
useEffect(() => {
    if (userid) {
        loadData(userid);
    }
}, [userid]);
const loadData = async (userid) => {
    setLoading(true);
    try {
        const res = await axios.get("/Components_Data/emi_status", {
            params: { userid }   // 👈 passes ?userid=123
        });
        setData(res.data);
    } catch (err) {
        console.error(err);
    } finally {
        setLoading(false);
    }
};
/* ---------- UI Helpers ---------- */
const statusTemplate = (row) => {
    const severity =
    row.EMIStatus === "COLLECTED"
    ? "success"
    : row.EMIStatus === "OVERDUE"
    ? "danger"
    : row.EMIStatus === "DUE TODAY"
    ? "warning"
    : "info";
    return <Tag value={row.EMIStatus} severity={severity} />;
};
const amountTemplate = (row, field) => {
    let value = row[field];

    if (value === null || value === undefined || value === "") {
        return "-";
    }

    // trim + convert (important)
    value = Number(String(value).trim());

    if (isNaN(value)) {
        return "-";
    }

    return value.toLocaleString("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 2
    });
};


const dateTemplate = (row) =>
new Date(row.paydate).toLocaleDateString("en-GB");
const overdueTemplate = (row) =>
row.OverdueDays > 0 ? (
<span className="text-red-500 font-bold">{row.OverdueDays}</span>
) : (
"-"
);
	return (
		<main id="EmicollectionstatusPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('emicollectionstatus')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <DataSource   apiPath="components_data/get_users"  >
                        {({ response }) => {
                        const dropdownOptions = response?.map(x => ({
                        label: x.username || x.label, // adjust field
                        value: x.userid || x.value
                        })) || [];
                        return (
                        <>
                        <Dropdown
                        name="userid"
                        value={userid}
                        onChange={(e) => setuserid(e.value)}
                        options={dropdownOptions}
                        optionLabel="label"
                        optionValue="value"
                        filter   // 🔍 enables search box
                        showClear
                        placeholder="Select a User"
                        className="w-500"
                        />
                        </>
                        );
                        }}
                    </DataSource>
                </div>
                <div className="">
                    <div className="card">
                        <h3>EMI Collection Status</h3>
                        {loading && <ProgressBar mode="indeterminate" style={{ height: "4px" }} />}
                        <DataTable
                            value={data}
                            paginator
                            rows={15}
                            rowsPerPageOptions={[10, 15, 25, 50]}
                            loading={loading}
                            responsiveLayout="scroll"
                            showGridlines
                            stripedRows
                            filterDisplay="row"
                            emptyMessage="No EMI records found"
                            >
                            <Column field="branchcode" header="Branch" filter />
                                <Column field="groupid" header="Group" filter />
                                    <Column field="memberid" header="Member" filter />
                                        <Column field="loanaccountno" header="Loan A/c No" filter />
                                            <Column field="period" header="EMI #" style={{ width: "90px" }} />
                                                <Column
                                                    field="paydate"
                                                    header="Due Date"
                                                    body={dateTemplate}
                                                    filter
                                                    />
                                                    <Column
                                                        field="emiamount"
                                                        header="EMI Amount"
                                                        body={(row) => amountTemplate(row, "emiamount")}
                                                        />
                                                        <Column
                                                        field="collectedAmount"
                                                        header="Collected"
                                                        body={(row) => amountTemplate(row, "collectedAmount")}
                                                        style={{ textAlign: "right" }}
                                                        />
                                                            <Column
                                                                field="emiStatus"
                                                                header="Status"
                                                                body={statusTemplate}
                                                                filter
                                                                />
                                                                <Column
                                                                    field="overdueDays"
                                                                    header="OD Days"
                                                                    body={overdueTemplate}
                                                                    style={{ textAlign: "center", width: "90px" }}
                                                                    />
                                                                    <Column field="dpD_Bucket" header="DPD_Bucket" filter />
                                                                    </DataTable>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
		</main>
	);
}
